module.exports = __webpack_public_path__ + "img/mingzhi_icon_05.8ac8c77c.png";